export const orderDeliveryStatusColors = {
  None: "yellow",
  PartlyShipped: "green",
  Shipped: "green",
  Cancel: "red",
} as const;
